import React from 'react'
import css from './style.scss'
import cn from 'classnames'
import LazyLoad from 'react-lazyload'
import StoriesList from 'components/account_page/stories/list/index'


const EmptyPage=(props)=>{
  return (
    <div>
      <div className={css.emptyPage}>

      </div>
    </div>
  )
}

class StoriesGroup extends React.Component{
  constructor(props){
    super(props)
    this.state={inList:false}
  }

  render(){
    if(this.props.groupedStories.length===0){
      return (
        <EmptyPage/>
      )
    }else{
      return (
        <div className={cn(css.calendar, this.props.className)}>
          {this.props.groupedStories.map(group=>
            <LazyLoad   key={group.date}
             offset={322} once>
              <StoriesList
                selectedStories={this.props.selectedAdventures}
                onSelect={this.props.onAdventureCheck}
                select={this.props.adventureDialog}
                day={group.date}
                key={group.date}
                miniStats
                stories={group.stories}
              />
            </LazyLoad>
          )}
        </div>
      )
    }

  }
}

export default StoriesGroup;



// WEBPACK FOOTER //
// ./src/components/account_page/stories/stories_group/index.js